/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { GetL2DepthOptions, GetL2DepthResponses } from '../types/GetL2Depth'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Get the aggregated price levels for a specific orderbook (L2 market depth)
 * {@link /v1/orderbooks/:order_book_id/L2}
 */
export function getL2Depth<ThrowOnError extends boolean = true>(
  options: Options<GetL2DepthOptions, ThrowOnError>,
): Unwrappable<RequestResult<GetL2DepthResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/orderbooks/{order_book_id}/L2',
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<GetL2DepthResponses, ThrowOnError>>,
  )
}
